import React from 'react';
import { Link } from 'react-router-dom';
import { FiInstagram, FiFacebook, FiPhone, FiMail, FiMapPin } from 'react-icons/fi';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-decoration"></div>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3 className="footer-logo">Sfension</h3>
            <p className="footer-tagline">Mesto gde se trenuci pamte</p>
            <div className="social-links">
              <a href="https://www.instagram.com/restoran_sfension?igsh=dWl0MnpzNHZheXpp" target="_blank" rel="noreferrer"><FiInstagram /></a>
              {/* <a href="https://facebook.com" target="_blank" rel="noreferrer"><FiFacebook /></a> */}
            </div>
          </div>

          <div className="footer-section">
            <h4>Navigacija</h4>
            <Link to="/">Početna</Link>
            <Link to="/meni">Meni</Link>
            <Link to="/rezervacije">Rezervacije</Link>
            <Link to="/galerija">Galerija</Link>
            <Link to="/o-nama">O nama</Link>
            <Link to="/kontakt">Kontakt</Link>
          </div>

          <div className="footer-section">
            <h4>Radno vreme</h4>
            <p>Ponedeljak - Nedelja</p>
            <span>08:00 - 23:00</span>
          </div>

          <div className="footer-section">
            <h4>Kontakt</h4>
            <a href="tel:+381669811881" className="contact-item">
              <FiPhone /> +381 66 981 1881
            </a>
            <a href="mailto:info@sfension.rs" className="contact-item">
              <FiMail /> info@sfension.rs
            </a>
            <a 
    href="https://maps.google.com/?q=Restaurant+Sfensioni,+Zvečan" 
    target="_blank" 
    rel="noopener noreferrer" 
    className="contact-item"
  >
    <FiMapPin /> Kralja Petra I, Zvečan
  </a>
          </div>

          <div className="footer-section footer-map-section">
            <h4>Dođite do nas</h4>
            <div className="footer-map-wrapper">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d217.19721463094342!2d20.842362155863587!3d42.90985791054919!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x135345786400e23b%3A0x4618cd79d8f9244b!2sRestaurant%20Sfensioni!5e0!3m2!1ssr!2s!4v1775903119534!5m2!1ssr!2s"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Sfension lokacija"
              />
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Sfension. Sva prava zadržana.</p>
          <a 
            href="https://mstechs.cloud" 
            target="_blank" 
            rel="noreferrer" 
            className="footer-credits"
          >
            
            <span className="credits-text">Powered by <strong>MStechs</strong></span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;